import { autoinject } from 'aurelia-dependency-injection';
import { IsinTaxableConfigurationsClient, IsinTaxableConfiguration } from '@dynamik/common/clients/transaction-clients';
import { CacheService } from '@dynamik/common';

@autoinject
export class IsinTaxableConfigurationsCache {
  constructor(private itcClient: IsinTaxableConfigurationsClient, private cacheService: CacheService) { }

  data: IsinTaxableConfiguration[];

  async get() {
    return this.cacheService.getOrSet('isin-taxable-configurations', () => this.itcClient.get().then(x => this.data = x), 6000000000);
  }

  isTaxable(isin: string) {
    return this.data.find(y => y.isin === isin?.substring(0, 2))?.taxable;
  }
}
